/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import classnames from "classnames";

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./content.scss";

const Content = ({ children, centered }) => {
  const classes = classnames("report-builder__content", { centered });

  return (
    <Box className={classes} padding="large">
      {children}
    </Box>
  );
};

export default Content;
